(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.titles)

(defn resolve-dasos-titles-with-lang
  "Finnish, english or swedish (coming later)"
  [key lang]
  (let [lang-orders {:ENG 0
                     :FI 1
                     :SWE 2}
        chosen-lang (get lang-orders lang)
        titles {:basic-information ["Basic information" "Perustiedot" ""]
                :nav-per-unit-series ["NAV per unit series (EUR)" "Osuussarjojen arvot (EUR)" ""]
                :total-return-by-unit-series ["Total return by unit series (%)" "Kokonaistuotot kulujen jälkeen (%)" ""]
                :unit-value ["Unit value (EUR)" "Rahasto-osuuden arvonkehitys (EUR)" ""]
                :portfolio-allocation ["Portfolio allocation" "Salkun omaisuuslajit" ""]
                :portfolio-by-country-fair-value ["Portfolio fair value by country" "Salkku maittain" ""]
                :investments-map ["Portfolio countries" "Rahaston kohdemaat" ""]}]
    (if lang
      (get-in titles [key chosen-lang])
      (get-in titles [key 0]))))
